// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCloudServicesError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.83333 2C4.4375 2 2.38814 3.71463 2.08129 6.01224C0.844377 6.77327 0 8.11254 0 9.66667C0 12.1053 2.06126 14 4.5 14H5.80269C5.45134 13.3926 5.2034 12.7179 5.08296 12H4.5C3.07275 12 2 10.9099 2 9.66667C2 8.75373 2.56814 7.93409 3.44227 7.55201L4.04636 7.28796L4.04173 6.62869L4.04167 6.61111C4.04167 5.21445 5.245 4 6.83333 4C7.86219 4 8.74366 4.51797 9.22591 5.2656L9.22645 5.26644C9.78698 5.09325 10.3826 5 11 5C12.0743 5 13.0826 5.28234 13.9549 5.77686C13.3917 4.51881 12.0884 3.66667 10.625 3.66667C10.5907 3.66667 10.5565 3.66713 10.5224 3.66805C9.63882 2.64317 8.30811 2 6.83333 2Z" class="svg-bg"/>
  <circle cx="11" cy="11" r="5" fill="#ED5353"/>
  <circle cx="11" cy="11" r="5" class="svg-fg-stroke"/>
  <path d="M12.7676 14.1804L14.1818 12.7662L12.4144 10.9987L14.182 9.23115L12.7678 7.81693L11.0002 9.58451L9.23208 7.81641L7.81787 9.23062L9.58598 10.9987L7.81802 12.7667L9.23223 14.1809L11.0002 12.4129L12.7676 14.1804Z" class="svg-fg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 18.75C24 21.6495 21.6495 24 18.75 24C15.8505 24 13.5 21.6495 13.5 18.75C13.5 15.8505 15.8505 13.5 18.75 13.5C21.6495 13.5 24 15.8505 24 18.75Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path d="M10 5C7.51472 5 5.5 7.01472 5.5 9.5C5.5 9.69907 5.51287 9.89464 5.5377 10.086L5.64666 10.9257L4.83639 11.1716C3.19378 11.6701 2 13.1969 2 15C2 17.2091 3.79086 19 6 19H11.5042C11.5278 19.696 11.6495 20.3671 11.8559 21H6C2.68629 21 0 18.3137 0 15C0 12.5773 1.43522 10.492 3.50015 9.54429L3.5 9.5C3.5 5.91015 6.41015 3 10 3C12.3457 3 14.3995 4.24243 15.5421 6.10238C15.8513 6.03528 16.1718 6 16.5 6C18.9853 6 21 8.01472 21 10.5C21 10.5332 20.9996 10.5664 20.9989 10.5995C22.1332 11.179 23.0402 12.1409 23.5492 13.3157C22.2925 12.2051 20.6477 11.5235 18.8441 11.5006L18.9456 11.0224C18.9811 10.8548 19 10.6801 19 10.5C19 9.11929 17.8807 8 16.5 8C16.1283 8 15.7782 8.08046 15.4637 8.22397L14.5365 8.6471L14.1311 7.71199C13.4384 6.1144 11.8482 5 10 5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCloudServicesError is a generated icon component.
 */
let IconMedCloudServicesError = IconMedCloudServicesError_1 = class IconMedCloudServicesError extends IconBaseElement {
    render() {
        return html `${IconMedCloudServicesError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCloudServicesError.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedCloudServicesError = IconMedCloudServicesError_1 = __decorate([
    customElement('zui-icon-med-cloud-services-error')
], IconMedCloudServicesError);
export { IconMedCloudServicesError };
